/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 17:32:48
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-25 14:30:10
 */
import { Request } from "./request";

export interface AccountStationParams {
    pn?: number;
    department?: string;
    password?: string;
    nickName?: string;
    ps?: number;
    status?: number;
    userName?: string;
    id?: string;
    userId?: string;
}

export interface AccountStationBody {
    userId?: number;
    pwd?: string;
    nickName?: string;
    status?: number;
    userName?: string;
}

export function AccountStationPage(body: AccountStationParams): Request {
    return {
        url: `/api/sys/user/list`,
        method: "POST",
        body,
    }
}

export function AccountStationSubmit(body: AccountStationBody): Request {
    return {
        url: `/api/sys/user/save`,
        method: "POST",
        body
    }
}

export function AccountStationChange(userId: number): Request {
    return {
        url: `/api/sys/user/status/change`,
        method: "POST",
        body: {
            userId,
        }
    }
}

export function AccountStationDetail(userId: number): Request {
    return {
        url: `/api/sys/user/info`,
        method: "GET",
        params: {
            userId
        }
    }
}
